<template>
  <div class="drop-zone__container">
    <div v-show="0 !== model.length" class="drop-zone__files">
      <div v-for="file in model" class="drop-zone__file">
        <img src="@/assets/icons/paper-clip.svg" alt="added file" />
        <span class="drop-zone__file-name">
          {{ file.name }}
        </span>
      </div>
    </div>
    <div v-if="validate.$error && validate.$dirty" class="drop-zone__error">
      {{ validate.$errors[0].$message }}
    </div>
    <label
      ref="dropZoneRef"
      class="drop-zone"
      :class="[
        { over: isOverDropZone },
        { error: validate.$error && validate.$dirty },
      ]"
      for="downloadFile"
      title="Drag and Drop"
    >
      <img src="@/assets/icons/blue-folder.svg" alt="drop file" />
      <span class="drop-zone__caption">
        <span>{{ _T("@Attach image") }}</span>
        <span>
          {{ _T("@Maximum file size") }} {{ Math.trunc(maxSize / 1000000) }}Mb
        </span>
      </span>
    </label>
    <input
      id="downloadFile"
      class="drop-zone__input"
      type="file"
      :multiple="true"
      :accept="fileTypes.toString()"
      @click="clearUploadedFiles"
      @change="onFileChange"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  fileTypes: { Type: Array, required: true },
  maxSize: { Type: Number, required: true },
  validate: { type: Object, required: true },
});

const model = defineModel();
const dropZoneRef = ref(null);

const onDrop = (files) => {
  model.value = files;
  props.validate.$touch();
};

const onFileChange = (event) => {
  model.value = Array.from(event.target.files);
  props.validate.$touch();
};

const clearUploadedFiles = () => {
  model.value = [];
};

const { isOverDropZone } = useDropZone(dropZoneRef, {
  onDrop,
  dataTypes: props.fileTypes,
});
</script>

<style scoped lang="scss">
.drop-zone {
  width: 100%;

  @include flex-container(row, center, center);
  gap: 16px;

  border: 1px dashed var(--color-blue-base);
  border-radius: 16px;
  background-color: var(--color-sky-light);

  padding: 24px 8px;

  &.over {
    background-color: rgba(72, 167, 248, 0.2);
  }

  &.error {
    border-color: var(--color-red-error-500);
  }

  &__container {
    width: 100%;

    @include flex-container(column, flex-start, center);
    gap: 24px;
  }

  &__files {
    @include flex-container(row, flex-start, center);
    flex-wrap: wrap;
    gap: 8px;
  }

  &__file {
    @include flex-container(row, flex-start, center);
    gap: 8px;
  }

  &__input {
    display: none;
    opacity: 0;
    visibility: hidden;
  }

  &__caption {
    @include flex-container(column, flex-start, flex-start);
    gap: 8px;

    @include font(14, 16);
    color: var(--color-ink-lightest);

    span + span {
      @include font(12, 14);
    }
  }

  &__error {
    @include font(14, 16);

    color: var(--color-red-error-500);
  }
}
</style>
